query LookupCarrierSearch(
  $lookupCarrier: String!
  $isAirlineLookup: Boolean!
  $isTrainLookup: Boolean!
  $isBusLookup: Boolean!
  $first: Int!
) {
  lookupCarrierSearch(
    lookupCarrier: $lookupCarrier
    isAirlineLookup: $isAirlineLookup
    isTrainLookup: $isTrainLookup
    isBusLookup: $isBusLookup
    first: $first
    orderBy: _SORT_ORDER_ASC
  ) {
    nodes {
      id
      name
      description
    }
  }
}
